// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/ckeditor5/dist/ckeditor5-content.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js!../../../../node_modules/ckeditor5-premium-features/dist/ckeditor5-premium-features-content.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../../node_modules/css-loader/dist/cjs.js!./plugins/Placeholder/style.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * DOCX export styles - includes:
 * - Content styles for document rendering
 * - Custom content styling overrides
 *
 * Loaded from docx.css entry point - used only for DOCX export generation.
 */

/** Custom CKEditor Content theming */
.ck-content {
  --ck-content-color-mention-background: hsla(341, 100%, 30%, 0.1);
  --ck-content-color-mention-text: hsl(341, 100%, 30%);

  --ck-content-font-family: Arial;
  --ck-content-font-size: 0.9rem;
  --ck-content-font-color: #000;
  --ck-content-line-height: 1.5;
  --ck-content-word-break: break-word;

  --ck-content-font-size-tiny: 0.7em;
  --ck-content-font-size-small: 0.85em;
  --ck-content-font-size-big: 1.4em;
  --ck-content-font-size-huge: 1.8em;

  --ck-content-highlight-marker-yellow: hsl(60, 97%, 73%);
  --ck-content-highlight-marker-green: hsl(120, 93%, 68%);
  --ck-content-highlight-marker-pink: hsl(345, 96%, 73%);
  --ck-content-highlight-marker-blue: hsl(201, 97%, 72%);
  --ck-content-highlight-pen-red: hsl(0, 85%, 49%);
  --ck-content-highlight-pen-green: hsl(112, 100%, 27%);

  --ck-content-color-image-caption-background: hsl(0, 0%, 97%);
  --ck-content-color-image-caption-text: hsl(0, 0%, 20%);

  --ck-content-image-style-spacing: 1.5em;
  --ck-content-inline-image-style-spacing: calc(var(--ck-content-image-style-spacing) / 2);

  --ck-content-list-marker-color: var(--ck-content-font-color);
  --ck-content-list-marker-font-family: var(--ck-content-font-family);
  --ck-content-list-marker-font-size: var(--ck-content-font-size);

  --ck-content-todo-list-checkmark-size: 16px;

  --ck-content-color-table-caption-background: hsl(0, 0%, 97%);
  --ck-content-color-table-caption-text: hsl(0, 0%, 20%);

  --ck-content-table-of-contents-padding: 1em;
  --ck-content-table-of-contents-line-height: 1.5;
  --ck-content-table-of-contents-items-start-padding: 24px;
}

/** Custom Pocketlaw selector theming */

.ck-content {
  --pl-content-headers-margin-top: 1.25rem;
  --pl-content-headers-margin-bottom: 0.75rem;
  --pl-content-text-margin: 0.5rem;
  --pl-content-line-height: 120%;
  --pl-content-font-size-h1: 1.35rem;
  --pl-content-font-size-h2: 1.15rem;
  --pl-content-font-size-h3: 1rem;
  --pl-content-font-size-h4: var(--ck-content-font-size);
  --pl-content-font-size-p: var(--ck-content-font-size);

  --t-lineHeight-default: var(--pl-content-line-height);

  /** Texts **/

  h1 {
    font-size: var(--pl-content-font-size-h1);
  }

  h2 {
    font-size: var(--pl-content-font-size-h2);
  }

  h3 {
    font-size: var(--pl-content-font-size-h3);
  }

  h4 {
    font-size: var(--pl-content-font-size-h4);
  }

  h1,
  h2,
  h3,
  h4 {
    font-weight: bold;
    line-height: var(--pl-content-line-height);
    margin-top: var(--pl-content-headers-margin-top);
    margin-bottom: var(--pl-content-headers-margin-bottom);
  }

  p {
    line-height: var(--pl-content-line-height);
    margin-top: var(--pl-content-text-margin);
    margin-bottom: var(--pl-content-text-margin);
  }

  /** Text Styles **/

  b,
  strong {
    font-weight: bold;
  }

  i {
    font-style: italic;
  }

  b,
  strong,
  i,
  u,
  s {
    line-height: var(--pl-content-line-height);
  }

  /** Lists **/

  ol,
  ul {
    padding-inline-start: 40px;
  }

  li {
    margin-top: var(--pl-content-text-margin);
    margin-bottom: var(--pl-content-text-margin);
    line-height: var(--pl-content-line-height);
  }

  ul:not(.multi-level-list),
  ol:not(.multi-level-list) {
    li:has(> h1:first-child)::marker {
      font-size: var(--pl-content-font-size-h1);
      font-weight: bold;
    }

    li:has(> h2:first-child)::marker {
      font-size: var(--pl-content-font-size-h2);
      font-weight: bold;
    }

    li:has(> h3:first-child)::marker {
      font-size: var(--pl-content-font-size-h3);
      font-weight: bold;
    }

    li:has(> h4:first-child)::marker {
      font-size: var(--pl-content-font-size-h4);
      font-weight: bold;
    }

    li:has(> span:first-child)::marker {
      font-size: var(--pl-content-font-size-p);
    }
  }

  /** Indentation */

  .ck-custom-block-indent-1 {
    margin-left: 40px;
  }

  .ck-custom-block-indent-2 {
    margin-left: 80px;
  }

  .ck-custom-block-indent-3 {
    margin-left: 120px;
  }

  /** Images **/

  figure {
    margin-block-start: 0px;
    margin-block-end: 0px;
  }

  figure.image {
    margin: 0 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./shared/domains/pleditor@next/content-styles.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAMF,qCAAqC;AACrC;EACE,gEAAgE;EAChE,oDAAoD;;EAEpD,+BAA+B;EAC/B,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,mCAAmC;;EAEnC,kCAAkC;EAClC,oCAAoC;EACpC,iCAAiC;EACjC,kCAAkC;;EAElC,uDAAuD;EACvD,uDAAuD;EACvD,sDAAsD;EACtD,sDAAsD;EACtD,gDAAgD;EAChD,qDAAqD;;EAErD,4DAA4D;EAC5D,sDAAsD;;EAEtD,uCAAuC;EACvC,wFAAwF;;EAExF,4DAA4D;EAC5D,mEAAmE;EACnE,+DAA+D;;EAE/D,2CAA2C;;EAE3C,4DAA4D;EAC5D,sDAAsD;;EAEtD,2CAA2C;EAC3C,+CAA+C;EAC/C,wDAAwD;AAC1D;;AAEA,uCAAuC;;AAEvC;EACE,wCAAwC;EACxC,2CAA2C;EAC3C,gCAAgC;EAChC,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,sDAAsD;EACtD,qDAAqD;;EAErD,qDAAqD;;EAErD,YAAY;;EAEZ;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;;;;IAIE,iBAAiB;IACjB,0CAA0C;IAC1C,gDAAgD;IAChD,sDAAsD;EACxD;;EAEA;IACE,0CAA0C;IAC1C,yCAAyC;IACzC,4CAA4C;EAC9C;;EAEA,kBAAkB;;EAElB;;IAEE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;;IAKE,0CAA0C;EAC5C;;EAEA,YAAY;;EAEZ;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,yCAAyC;IACzC,4CAA4C;IAC5C,0CAA0C;EAC5C;;EAEA;;IAEE;MACE,yCAAyC;MACzC,iBAAiB;IACnB;;IAEA;MACE,yCAAyC;MACzC,iBAAiB;IACnB;;IAEA;MACE,yCAAyC;MACzC,iBAAiB;IACnB;;IAEA;MACE,yCAAyC;MACzC,iBAAiB;IACnB;;IAEA;MACE,wCAAwC;IAC1C;EACF;;EAEA,iBAAiB;;EAEjB;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA,aAAa;;EAEb;IACE,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/**\n * DOCX export styles - includes:\n * - Content styles for document rendering\n * - Custom content styling overrides\n *\n * Loaded from docx.css entry point - used only for DOCX export generation.\n */\n@import '~ckeditor5/ckeditor5-content.css';\n@import '~ckeditor5-premium-features/ckeditor5-premium-features-content.css';\n\n@import './plugins/Placeholder/style.css';\n\n/** Custom CKEditor Content theming */\n.ck-content {\n  --ck-content-color-mention-background: hsla(341, 100%, 30%, 0.1);\n  --ck-content-color-mention-text: hsl(341, 100%, 30%);\n\n  --ck-content-font-family: Arial;\n  --ck-content-font-size: 0.9rem;\n  --ck-content-font-color: #000;\n  --ck-content-line-height: 1.5;\n  --ck-content-word-break: break-word;\n\n  --ck-content-font-size-tiny: 0.7em;\n  --ck-content-font-size-small: 0.85em;\n  --ck-content-font-size-big: 1.4em;\n  --ck-content-font-size-huge: 1.8em;\n\n  --ck-content-highlight-marker-yellow: hsl(60, 97%, 73%);\n  --ck-content-highlight-marker-green: hsl(120, 93%, 68%);\n  --ck-content-highlight-marker-pink: hsl(345, 96%, 73%);\n  --ck-content-highlight-marker-blue: hsl(201, 97%, 72%);\n  --ck-content-highlight-pen-red: hsl(0, 85%, 49%);\n  --ck-content-highlight-pen-green: hsl(112, 100%, 27%);\n\n  --ck-content-color-image-caption-background: hsl(0, 0%, 97%);\n  --ck-content-color-image-caption-text: hsl(0, 0%, 20%);\n\n  --ck-content-image-style-spacing: 1.5em;\n  --ck-content-inline-image-style-spacing: calc(var(--ck-content-image-style-spacing) / 2);\n\n  --ck-content-list-marker-color: var(--ck-content-font-color);\n  --ck-content-list-marker-font-family: var(--ck-content-font-family);\n  --ck-content-list-marker-font-size: var(--ck-content-font-size);\n\n  --ck-content-todo-list-checkmark-size: 16px;\n\n  --ck-content-color-table-caption-background: hsl(0, 0%, 97%);\n  --ck-content-color-table-caption-text: hsl(0, 0%, 20%);\n\n  --ck-content-table-of-contents-padding: 1em;\n  --ck-content-table-of-contents-line-height: 1.5;\n  --ck-content-table-of-contents-items-start-padding: 24px;\n}\n\n/** Custom Pocketlaw selector theming */\n\n.ck-content {\n  --pl-content-headers-margin-top: 1.25rem;\n  --pl-content-headers-margin-bottom: 0.75rem;\n  --pl-content-text-margin: 0.5rem;\n  --pl-content-line-height: 120%;\n  --pl-content-font-size-h1: 1.35rem;\n  --pl-content-font-size-h2: 1.15rem;\n  --pl-content-font-size-h3: 1rem;\n  --pl-content-font-size-h4: var(--ck-content-font-size);\n  --pl-content-font-size-p: var(--ck-content-font-size);\n\n  --t-lineHeight-default: var(--pl-content-line-height);\n\n  /** Texts **/\n\n  h1 {\n    font-size: var(--pl-content-font-size-h1);\n  }\n\n  h2 {\n    font-size: var(--pl-content-font-size-h2);\n  }\n\n  h3 {\n    font-size: var(--pl-content-font-size-h3);\n  }\n\n  h4 {\n    font-size: var(--pl-content-font-size-h4);\n  }\n\n  h1,\n  h2,\n  h3,\n  h4 {\n    font-weight: bold;\n    line-height: var(--pl-content-line-height);\n    margin-top: var(--pl-content-headers-margin-top);\n    margin-bottom: var(--pl-content-headers-margin-bottom);\n  }\n\n  p {\n    line-height: var(--pl-content-line-height);\n    margin-top: var(--pl-content-text-margin);\n    margin-bottom: var(--pl-content-text-margin);\n  }\n\n  /** Text Styles **/\n\n  b,\n  strong {\n    font-weight: bold;\n  }\n\n  i {\n    font-style: italic;\n  }\n\n  b,\n  strong,\n  i,\n  u,\n  s {\n    line-height: var(--pl-content-line-height);\n  }\n\n  /** Lists **/\n\n  ol,\n  ul {\n    padding-inline-start: 40px;\n  }\n\n  li {\n    margin-top: var(--pl-content-text-margin);\n    margin-bottom: var(--pl-content-text-margin);\n    line-height: var(--pl-content-line-height);\n  }\n\n  ul:not(.multi-level-list),\n  ol:not(.multi-level-list) {\n    li:has(> h1:first-child)::marker {\n      font-size: var(--pl-content-font-size-h1);\n      font-weight: bold;\n    }\n\n    li:has(> h2:first-child)::marker {\n      font-size: var(--pl-content-font-size-h2);\n      font-weight: bold;\n    }\n\n    li:has(> h3:first-child)::marker {\n      font-size: var(--pl-content-font-size-h3);\n      font-weight: bold;\n    }\n\n    li:has(> h4:first-child)::marker {\n      font-size: var(--pl-content-font-size-h4);\n      font-weight: bold;\n    }\n\n    li:has(> span:first-child)::marker {\n      font-size: var(--pl-content-font-size-p);\n    }\n  }\n\n  /** Indentation */\n\n  .ck-custom-block-indent-1 {\n    margin-left: 40px;\n  }\n\n  .ck-custom-block-indent-2 {\n    margin-left: 80px;\n  }\n\n  .ck-custom-block-indent-3 {\n    margin-left: 120px;\n  }\n\n  /** Images **/\n\n  figure {\n    margin-block-start: 0px;\n    margin-block-end: 0px;\n  }\n\n  figure.image {\n    margin: 0 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
